import "../styles/index.scss";
import ScrollSniffer from "scroll-sniffer";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";

// bump

hljs.initHighlightingOnLoad();

const listener = new ScrollSniffer(".listen");
listener.listen();

const ball = document.querySelector(".ball");
const content = document.querySelector(".content");
const underlay = document.querySelector(".underlay");
const event = document.querySelector("#event");
const direction = document.querySelector("#direction");
const atTop = document.querySelector("#at_top");
const atBottom = document.querySelector("#at_bottom");
const ballInner = document.querySelector("#ball_inner");

ball.addEventListener("Scroll:in:bottom", () => {
  event.innerHTML = `Event: "Scroll:in:bottom"`;
  ball.classList.add("text-top");
  ballInner.innerHTML = `In from the bottom`;
});

ball.addEventListener("Scroll:allIn:bottom", () => {
  event.innerHTML = `Event: "Scroll:allIn:bottom"`;
  ball.classList.remove("text-top");
  ballInner.innerHTML = `All in from bottom`;
});

ball.addEventListener("Scroll:out:bottom", () => {
  event.innerHTML = `Event: "Scroll:out:bottom"`;
  ball.classList.add("text-top");
  ballInner.innerHTML = `Out the bottom`;
});

ball.addEventListener("Scroll:allOut:bottom", () => {
  event.innerHTML = `Event: "Scroll:allOut:bottom"`;
});

ball.addEventListener("Scroll:in:top", () => {
  event.innerHTML = `Event: "Scroll:in:top"`;
  ballInner.innerHTML = `In from the top`;
});

ball.addEventListener("Scroll:allIn:top", () => {
  event.innerHTML = `Event: "Scroll:allIn:top"`;
  ball.classList.remove("text-bottom");
  ballInner.innerHTML = `All in from the top`;
});

ball.addEventListener("Scroll:out:top", () => {
  event.innerHTML = `Event: "Scroll:out:top"`;
  ball.classList.add("text-bottom");
  ballInner.innerHTML = `Out the top`;
});

ball.addEventListener("Scroll:allOut:top", () => {
  event.innerHTML = `Event: "Scroll:allOut:top"`;
});

document.addEventListener("Scroll:up", () => {
  direction.innerHTML = `Event: "Scroll:up"`;
});

document.addEventListener("Scroll:down", () => {
  direction.innerHTML = `Event: "Scroll:down"`;
});

document.addEventListener("Scroll:atTop?", (e) => {
  atTop.innerHTML = e.detail.atTop ? `True` : `False`;
});

document.addEventListener("Scroll:atBottom?", (e) => {
  atBottom.innerHTML = e.detail.atBottom ? `True` : `False`;
});

content.addEventListener("Scroll:in", () => {
  underlay.classList.add("hide");
});

content.addEventListener("Scroll:allOut", () => {
  underlay.classList.remove("hide");
});